query TravelPolicies {
  travelPolicies(orderBy: DESCRIPTION_ASC) {
    nodes {
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      description
      currencyId
      companyCurrency {
        id
        isoCode
        name
      }
      isDefaultCustomizable
      isContractual
      isCompanion
      companionTickets
      companionAmount
      isEconomyClassAllowed
      isPremiumClassAllowed
      isBusinessClassAllowed
      isFirstClassAllowed
      isCharterClassAllowed
      travelPolicyAllowancesByTravelPolicyId(orderBy: SORT_ORDER_ASC) {
        nodes {
          id
          _rowTimestamp
          _isUpdatable
          _isDeletable
          expenditureTypeId
          expenditureType {
            expenditureType
          }
          policyAllowance
          policyMiles
          isAllowanceCustomizable
        }
        totalCount
      }
    }
  }
}
